export const mutations = {
  addChargement (state, chargement) {
    state.chargement = chargement
  },
  setChargement (state, chargement) {
    state.chargement = chargement
  },
    addChargements(state, chargement){
    state.chargements = [ ...chargement ]
  },
}
